import fire from '../conf/initFirebase';
const itemRef = fire.database().ref('guides');

const GuidesActions = Object.freeze({

    get: () => {
        return itemRef;
    },

    create: values => {
        return itemRef.push(values);
    },

    delete: id => {
        return fire.database().ref('guides/' + id).remove()
    },

    edit: (values) => {
        return fire.database().ref('guides/' + values.id).update(values);
    },

    fetchGuides: () => {
        return itemRef.orderByChild('created_at').limitToLast(100)
    }
});

export default GuidesActions;


// WEBPACK FOOTER //
// ./src/actions/guides.action.js